<template>
    <div class="scope-arrangement-setting">
        <div class="box-shadow-small border-radius">
            <div class="">
                <h1 class="clearfix mt-15 ml-20"><strong>面试安排</strong></h1>
                <div class="mb-15">
                    <thumbnail :text="baseInfo.name" :gender="baseInfo.gender=== 1 ? 'man': 'woman'" :font-size="16" :width="110"></thumbnail>
                    <el-row class="mt-10 text-center" :gutter="10">
                        <el-col :span="8">应聘职位：{{ baseInfo.positionName }}</el-col>
                        <el-col :span="8">应聘部门：{{ baseInfo.deptNames }}</el-col>
                        <el-col :span="8">手机号：{{ baseInfo.mobilePhone }}</el-col>
                    </el-row>
                </div>
            </div>
            <div class="mt-20">
                <el-row class="arrangement-list">
                    <arrangement-item :init="baseData"
                                      @sendEmail="sendEmail"
                                      ref="arrangement">
                    </arrangement-item>
                </el-row>
            </div>
        </div>
        <email-sender ref="sendEmail"></email-sender>
    </div>
</template>

<script type="text/javascript">
    import Thumbnail from 'components/thumbnail'
    import ArrangementItem from './arrangementItem.vue'
    import EmailSender from '../operation/interviewerEmailDialog'

    export default {
        components: {
            Thumbnail, ArrangementItem, EmailSender
        },
        data () {
            return {
                urls: {
                    fetch: '/resumePosition/interviewArrange/list.api'
                },
                interviewObject: {
                    interviewDate: new Date(),
                    interviewType: null,
                    interviewer: null,
                    interviewerUsers: [],
                    isHr: '',
                    interviewPlace: ''
                },
                baseInfo: {},  // 基本信息
                baseData: {}  // item's data
            }
        },
        computed: {
            id () {
                return this.$route.params.id
            }
        },
        methods: {
            fetchData () {
                this.$axios.get(this.urls.fetch, {
                    params: {
                        resumePositionId: this.id
                    }
                }).then(res => {
                    this.baseInfo = Object.assign({}, res.result.resume, {
                        positionName: res.result.position.name,
                        deptNames: res.result.position.deptNames
                    })
                    res.result.list.forEach(form => {
                        form.turnType = [form.turn, form.isHr].join(',')
                    })
                    this.baseData = Object.assign({}, res.result, {
                        id: this.id
                    })
                    this.result = res.result
                }).catch(() => {})
            },
            sendEmail (data, type) {
                let ids = []
                let users = {}
                data.forEach(item => {
                    ids.push(item.id)
                    let masterIds = item.masterInterviewer.split(','),
                        masterNames = item.masterInterviewerNames.split('，'),
                        interviewIds = item.interviewer.split(','),
                        interviewNames = item.interviewerNames.split('，')
                    item.interviewerUsers = []
                    if (item.masterInterviewer !== '') {
                        masterIds.forEach((mid, mindex) => {
                            users[mid] = masterNames[mindex]
                            item.interviewerUsers.push({
                                id: mid,
                                name: masterNames[mindex]
                            })
                        })
                    }
                    if (item.interviewer !== '') {
                        interviewIds.forEach((iid, iindex) => {
                            users[iid] = interviewNames[iindex]
                            item.interviewerUsers.push({
                                id: iid,
                                name: interviewNames[iindex]
                            })
                        })
                    }
                })
                this.$refs.sendEmail.show({
                    ids: this.baseData.id,
                    interviewIds: ids.join(','),
                    selecteds: data,
                    resumePositionList: [this.result],
                    phase: 2,
                    userAttributes: type
                })
            }
        },
        created () {
            this.fetchData()
        }
    }
</script>

<style type="text/css" lang="scss">
    @import "~style/app/arrangement.scss";
</style>


// WEBPACK FOOTER //
// arrangement.vue?5b908b05